export default __webpack_public_path__ + "static/media/IMG_0502.270c7102.JPG";